import axios from 'Axios';
import {
  PROJECTS_ENDPOINT,
  GET_PROJECT_USAGES,
  usersAccepted,
  usersInvited,
  inviteUserToProject,
  removeUserFromProject,
  USER_INVITATIONS,
  acceptInvitationToProject,
  declineInvitationToProject,
  excelImportNew,
  excelImportAll,
  excelImportManually,
  excelExport,
  ISSUE_DRAFT,
  excelImportTypes,
} from '../api/Routes';

import { addDemandDashboardProject } from 'Actions/initActions';
import { getCurrentProject } from './ticketActions';

function getProjetsStart() {
  return {
    type: 'GET_PROJECTS_START',
  };
}

function getProjetsDone(data) {
  return {
    type: 'GET_PROJECTS_DONE',
    projects: data,
  };
}

function getProjectUsagesDone(data) {
  return {
    type: 'GET_PROJECT_USAGES_DONE',
    projectUsages: data,
  };
}

function editProjectStart() {
  return {
    type: 'EDIT_PROJECT_START',
  };
}

function editProjectDone(data) {
  return {
    type: 'EDIT_PROJECT_DONE',
    project: data,
  };
}

function saveProjectStart() {
  return {
    type: 'SAVE_PROJECT_START',
  };
}

function saveProjectDone(data) {
  return function(dispatch) {
    dispatch(addDemandDashboardProject());
    dispatch({
      type: 'SAVE_PROJECT_DONE',
      project: data,
    });
  };
}

function deleteProjectStart() {
  return {
    type: 'DELETE_PROJECT_START',
  };
}

function deleteProjectDone(projectId) {
  return {
    type: 'DELETE_PROJECT_DONE',
    deletedProject: projectId,
  };
}

function getProjetUsagesStart() {
  return {
    type: 'GET_PROJECT_USAGES_START',
  };
}

function geUsersAcceptedStart() {
  return {
    type: 'GET_USERS_ACCEPTED_START',
  };
}

function geUsersAcceptedDone(data) {
  return {
    type: 'GET_USERS_ACCEPTED_DONE',
    usersAccepted: data,
  };
}

function geUsersInvitedStart() {
  return {
    type: 'GET_USERS_INVITED_START',
  };
}

function geUsersInvitedDone(data) {
  return {
    type: 'GET_USERS_INVITED_DONE',
    usersInvited: data,
  };
}

function inviteToProjectStart() {
  return {
    type: 'INVITE_TO_PROJECT_START',
  };
}

function inviteToProjectDone(data) {
  return {
    type: 'INVITE_TO_PROJECT_DONE',
    usersInvited: data,
  };
}

function removeUserFromProjectStart() {
  return {
    type: 'REMOVE_USER_FROM_PROJECT_START',
  };
}

function removeUserFromProjectDone(userId) {
  return {
    type: 'REMOVE_USER_FROM_PROJECT_DONE',
    userDeleted: userId,
  };
}

function getUserInvitationsStart() {
  return {
    type: 'GET_USER_INVITATIONS_START',
  };
}

function getUserInvitationsDone(data) {
  return {
    type: 'GET_USER_INVITATIONS_DONE',
    userInvitations: data,
  };
}

function acceptInvitationStart() {
  return {
    type: 'ACCEPT_INVITATION_START',
  };
}

function acceptInvitationDone(projectId) {
  return {
    type: 'ACCEPT_INVITATION_DONE',
    projectId,
  };
}

function declineInvitationStart() {
  return {
    type: 'DECLINE_INVITATION_START',
  };
}

function declineInvitationDone(projectId) {
  return {
    type: 'DECLINE_INVITATION_DONE',
    projectId,
  };
}
export function removeInvitation(projectId) {
  return {
    type: 'REMOVE_INVITATION',
  };
}

function projectsError(errorMessage) {
  return {
    type: 'PROJECTS_ERROR',
    errorMessage,
  };
}

export function projectSuccess(successMessage) {
  return {
    type: 'PROJECTS_SUCCESS',
    successMessage,
  };
}

export function criteriaErrors(error) {
  return {
    type: 'CRITERIA_ERRORS',
    criteriaErr: error,
  };
}

function excelImportOptionTypesStart() {
  return {
    type: 'IMPORT_EXCEL_OPTION_TYPES_START',
  };
}
function excelImportOptionTypesDone(options) {
  return {
    type: 'IMPORT_EXCEL_OPTION_TYPES_DONE',
    options,
  };
}

export const getProjects = () => {
  return function(dispatch) {
    dispatch(getProjetsStart());

    axios
      .get(PROJECTS_ENDPOINT)
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(getProjetsDone(data));
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(projectsError(errorMessage));
      });
  };
};

export const getProjectUsages = () => {
  return function(dispatch) {
    dispatch(getProjetUsagesStart());

    axios
      .get(GET_PROJECT_USAGES)
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(getProjectUsagesDone(data));
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(projectsError(errorMessage));
      });
  };
};

export const editProject = (projectId, projectObject) => {
  return function(dispatch) {
    dispatch(editProjectStart());

    axios
      .put(`${PROJECTS_ENDPOINT + '/' + projectId}`, projectObject)
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(editProjectDone(data));
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(projectsError(errorMessage));
      });
  };
};

export const saveProject = projectObject => {
  return function(dispatch) {
    dispatch(saveProjectStart());

    axios
      .post(PROJECTS_ENDPOINT, projectObject)
      .then(response => {
        // If request is good...
        const { status, statusText } = response;
        if (status >= 200 && status < 300) {
          return response.data;
        }

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(saveProjectDone(data));
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(projectsError(errorMessage));
      });
  };
};

export const deleteProject = projectId => {
  return function(dispatch) {
    dispatch(deleteProjectStart());

    axios
      .delete(`${PROJECTS_ENDPOINT + '/' + projectId}`)
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(deleteProjectDone(projectId));
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(projectsError(errorMessage));
      });
  };
};

export const getUsersAccepted = projectId => {
  return function(dispatch) {
    dispatch(geUsersAcceptedStart());

    axios
      .get(usersAccepted(projectId))
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(geUsersAcceptedDone(data));
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(projectsError(errorMessage));
      });
  };
};

export const getUsersInvited = projectId => {
  return function(dispatch) {
    dispatch(geUsersInvitedStart());

    axios
      .get(usersInvited(projectId))
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(geUsersInvitedDone(data));
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(projectsError(errorMessage));
      });
  };
};

export const inviteToProject = (projectId, usersArray) => {
  return function(dispatch) {
    dispatch(inviteToProjectStart(projectId));

    axios
      .post(inviteUserToProject(projectId), usersArray)
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(inviteToProjectDone(data));
        dispatch(getUsersInvited(projectId));
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(projectsError(errorMessage));
      });
  };
};

export const deleteUserFromProject = (projectId, userId) => {
  return function(dispatch) {
    dispatch(removeUserFromProjectStart());

    axios
      .delete(removeUserFromProject(projectId, userId))
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(removeUserFromProjectDone(userId));
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(projectsError(errorMessage));
      });
  };
};

export const getUserInvitations = () => {
  return function(dispatch) {
    dispatch(getUserInvitationsStart());

    axios
      .get(USER_INVITATIONS)
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(getUserInvitationsDone(data));
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(projectsError(errorMessage));
      });
  };
};

export const acceptInvitation = projectId => {
  return function(dispatch) {
    dispatch(acceptInvitationStart());

    axios
      .post(acceptInvitationToProject(projectId), {})
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(acceptInvitationDone(projectId));
        dispatch(getProjects());
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(projectsError(errorMessage));
      });
  };
};

export const declineInvitation = projectId => {
  return function(dispatch) {
    dispatch(declineInvitationStart());

    axios
      .post(declineInvitationToProject(projectId), {})
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(declineInvitationDone(projectId));
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        dispatch(projectsError(errorMessage));
      });
  };
};

export const importExcelAll = (projectId, excelFile) => {
  return function(dispatch) {
    axios
      .post(excelImportAll(projectId), excelFile)
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(projectSuccess('Successfuly imported'));
        if (data.criteriaErrors) dispatch(criteriaErrors(data.criteriaErrors));
        dispatch(getCurrentProject(projectId));
      })
      .catch(error => {
        dispatch(
          projectsError(
            'File is not correctly structured for import. Check file data!'
          )
        );
      });
  };
};

export const importExcelNew = (projectId, excelFile) => {
  return function(dispatch) {
    axios
      .post(excelImportNew(projectId), excelFile)
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(projectSuccess('Successfuly imported'));
        if (data.criteriaErrors) dispatch(criteriaErrors(data.criteriaErrors));
        dispatch(getCurrentProject(projectId));
      })
      .catch(error => {
        dispatch(
          projectsError(
            'File is not correctly structured for import. Check file data!'
          )
        );
      });
  };
};
export const importExcelManually = (projectId, excelFile, referenceNames) => {
  return function(dispatch) {
    axios
      .post(excelImportManually(projectId, referenceNames), excelFile)
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(projectSuccess('Successfuly imported'));
        if (data.criteriaErrors) dispatch(criteriaErrors(data.criteriaErrors));
        dispatch(getCurrentProject(projectId));
        dispatch(excelImportOptionTypesDone([]));
      })
      .catch(error => {
        dispatch(
          projectsError(
            'File is not correctly structured for import. Check file data!'
          )
        );
      });
  };
};

export const importExcelOptionTypes = (projectId, excelFile) => {
  return function(dispatch) {
    dispatch(excelImportOptionTypesStart());
    axios
      .post(excelImportTypes(projectId), excelFile)
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(excelImportOptionTypesDone(data));
      })
      .catch(error => {
        dispatch(
          projectsError(
            'File is not correctly structured for import. Check file data!'
          )
        );
      });
  };
};

export const downloadExportedFile = projectId => {
  return function(dispatch) {
    axios
      .get(excelExport(projectId), { responseType: 'blob' })
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        const handleSaveExportedFile = async file => {
          if (window.showSaveFilePicker) {
            const handle = await showSaveFilePicker({
              suggestedName: 'LuminaireSchedule.xlsx',
              types: [
                {
                  description: 'Excel File',
                  accept: { 'application/octet-stream': ['.xlsx'] },
                },
              ],
            });
            const writable = await handle.createWritable();
            await writable.write(file);
            writable.close();
          } else {
            const url = window.URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'LuminaireSchedule.xlsx';
            document.body.appendChild(link);
            link.click();
          }
        };

        const blob = new Blob([data]);
        handleSaveExportedFile(blob);
        dispatch(projectSuccess('Successfuly downloaded'));
      })
      .catch(error => {
        error.response.data.text().then(response => {
          const resData = JSON.parse(response);
          dispatch(projectsError(resData.message));
        });
      });
  };
};
export const issueDraftSearches = ({ ids, date }, projectId) => {
  return function(dispatch) {
    axios
      .get(ISSUE_DRAFT, {
        params: {
          ids: ids.reduce((f, s) => `${f},${s}`),
          date,
        },
      })
      .then(response => {
        // If request is good...
        const { status, statusText } = response;

        if (status >= 200 && status < 300) return response.data;

        let error = new Error(statusText);
        error.status = status;
        error.promise = response;
        throw error;
      })
      .then(data => {
        dispatch(getCurrentProject(projectId));
        dispatch(projectSuccess('Successfuly issued drafted searches'));
      })
      .catch(error => {
        if (error.response.data.criteriaErrors) {
          dispatch(criteriaErrors(error.response.data.criteriaErrors));
        } else {
          dispatch(projectsError(error.message));
        }
        dispatch(getCurrentProject(projectId));
      });
  };
};
